export default {
  brand: {
    name: 'VILLAGARAGE',
    tagline: 'Premium Garage Systems',
  },
  nav: {
    home: 'Ana Sayfa',
    garage: 'Garaj Sistemleri',
    villa: 'Villa Projeleri',
    winter: 'Kış Bahçesi',
    projects: 'Projeler',
    about: 'Hakkımızda',
    contact: 'İletişim',
    dealer: 'Bayilik & İş Ortaklığı',
    login: 'Üye / Bayi Girişi',
    cta: 'Projeniz İçin Teklif Al',
  },
  hero: {
    title1: 'Villanıza Değer Katan',
    title2: 'Premium Garaj Sistemleri',
    subtitle: 'Lüks villa projeleri ve bireysel villalar için mimariye özel premium kapalı garaj çözümleri.',
    cta1: 'Projeniz İçin Teklif Al',
    cta2: 'Garaj Sistemlerini İncele',
    small: '1 & 2 Araçlık Sistemler • Mimariye Özel Tasarım • Proje Bazlı Çözümler',
  },
  s1: {
    title: 'Garaj, Villanın Sonradan Eklenen Bir Parçası Olmamalı.',
    text: 'VILLAGARAGE garajı bağımsız bir yapı olarak değil, villanın mimarisinin bir parçası olarak ele alır.',
    f1: 'Mimariye özel tasarım',
    f2: 'Premium görünüm',
    f3: 'Dört mevsim araç koruması',
  },
  s2: {
    title: 'Aynı Villa. Farklı Bir Yaşam Standardı.',
    openTitle: 'Açık Otopark',
    openDesc: 'Araç dış etkenlere açık. Mimari bütünlük eksik. Projeye değer katmaz.',
    garageTitle: 'VILLAGARAGE Premium Garaj',
    garageDesc: 'Araç dört mevsim korunur. Villanın mimarisiyle bütünleşir. Projeye premium değer katar.',
    cta: 'Projeniz İçin Çözüm İsteyin',
  },
  s3: {
    title: 'Garaj Sistemleri',
    cta: 'İncele',
    card1: {
      title: 'Tek Araçlık Premium Garaj',
      desc: 'Tek araç için mimariye özel, kompakt ve şık premium garaj çözümü.',
    },
    card2: {
      title: 'Çift Araçlık Premium Garaj',
      desc: 'İki araç için geniş, ferah ve villanızla bütünleşen premium garaj.',
    },
    card3: {
      title: 'Projeye Özel Garaj Sistemleri',
      desc: 'Villa projelerine ve özel ihtiyaçlara göre tasarlanan özel çözümler.',
    },
  },
  s4: {
    title1: 'Her Villa Aynı Değil.',
    title2: 'Garajı da Aynı Olmamalı.',
    d1: 'Antrasit mimari sistemler',
    d2: 'Doğal ahşap detaylar',
    d3: 'Mimari aydınlatma',
    d4: 'Özel cephe tasarımları',
    d5: '1 & 2 araçlık çözümler',
  },
  s5: {
    title: 'Villa Projelerini Standarttan Ayıran Bir Detay',
    subtitle: 'İnşaat firmaları, proje geliştiricileri ve mimarlar için VILLAGARAGE.',
    b1: 'Projeye özel tasarım',
    b2: 'Villa mimarisiyle bütünleşme',
    b3: 'Çoklu villa projelerine uygun yapı',
    b4: 'Premium proje algısı',
    b5: 'Tek / çift araç çözümleri',
    b6: 'Geleneksel ağır yapı süreçlerine alternatif sistem yaklaşımı',
    cta: 'Villa Projenizi Gönderin',
  },
  s6: {
    title: 'Milyonluk Aracınız Dört Mevsim Açıkta Kalmasın.',
    text: 'Güneş, yağmur, dolu, kar ve dış etkenlere karşı daha korunaklı premium alan oluşturun.',
    cta: 'Villam İçin Garaj İstiyorum',
  },
  s7: {
    title: 'Villanız İçin Bütünsel Mimari Çözümler',
    subtitle: 'Premium Garaj + Kış Bahçesi',
    cta: 'Projem İçin Bilgi Al',
  },
  s8: {
    title: 'Projeniz Nasıl Başlıyor?',
    step1: 'Alanınızı Paylaşın',
    step1d: 'Villanız veya projeniz hakkında bize temel bilgileri iletin.',
    step2: 'İhtiyacı Belirleyelim',
    step2d: 'Araç kapasitesi ve kullanım senaryosunu birlikte netleştirelim.',
    step3: 'Tasarım Yaklaşımı',
    step3d: 'Mimarinize uygun özel bir tasarım yaklaşımı geliştirelim.',
    step4: 'Teklif',
    step4d: 'Proje kapsamına göre size özel teklif sunalım.',
    step5: 'Uygulama',
    step5d: 'Onay sonrası planlanan süreçte uygulamayı gerçekleştirelim.',
  },
  s9: {
    title: 'İlham Veren Garaj Projeleri',
    filterAll: 'Tümü',
    filterSingle: 'Tek Araçlık',
    filterDouble: 'Çift Araçlık',
    filterVilla: 'Villa Projeleri',
    filterWinter: 'Kış Bahçesi',
  },
  s10: {
    title: 'Villanıza veya Projenize Özel Bir Çözüm Tasarlayalım.',
  },
  form: {
    name: 'Ad Soyad',
    namePh: 'Adınız ve soyadınız',
    phone: 'Telefon',
    phonePh: '+90 5xx xxx xx xx',
    email: 'E-posta',
    emailPh: 'ornek@email.com',
    city: 'Şehir',
    cityPh: 'Yaşadığınız şehir',
    customerType: 'Müşteri Tipi',
    solution: 'İlgilendiğiniz Çözüm',
    projectStatus: 'Proje / Alan Durumu',
    message: 'Mesaj',
    messagePh: 'Projenizi kısaca anlatın...',
    upload: 'Görsel Yükleme',
    uploadHint: 'Arsa, villa veya referans görselleri yükleyebilirsiniz',
    submit: 'PROJEMİ GÖNDER',
    success: 'Talebiniz başarıyla alındı. En kısa sürede sizinle iletişime geçeceğiz.',
    error: 'Bir şeyler ters gitti. Lütfen tekrar deneyin.',
    customer: {
      villaOwner: 'Villa Sahibi',
      construction: 'İnşaat Firması',
      developer: 'Proje Geliştirici',
      architect: 'Mimar',
      investor: 'Yatırımcı',
      other: 'Diğer',
    },
    solutionOpt: {
      single: 'Tek Araçlık Garaj',
      double: 'Çift Araçlık Garaj',
      villaProject: 'Villa Projesi',
      winterGarden: 'Kış Bahçesi',
      combined: 'Garaj + Kış Bahçesi',
      custom: 'Özel Proje',
    },
    status: {
      land: 'Arsa / arazi var',
      construction: 'Villa inşaat halinde',
      existing: 'Mevcut villa',
      none: 'Henüz arsa yok',
      other: 'Diğer',
    },
  },
  whatsapp: {
    message: 'Merhaba VILLAGARAGE, villa / garaj projem için bilgi ve teklif almak istiyorum.',
  },
  mobile: {
    cta: 'Projeniz İçin Bilgi Al',
  },
  faq: {
    title: 'Sıkça Sorulan Sorular',
    q1: 'Mevcut villalara uygulanabilir mi?',
    a1: 'Evet. Hem yeni inşa edilen villalara hem de mevcut villalara uygun çözümler sunuyoruz. Mevcut villalarda alan ve mimari yapı değerlendirilerek projeye özel uygulama gerçekleştirilir.',
    q2: 'Tek ve çift araçlık sistemler var mı?',
    a2: 'Evet, tek araçlık ve çift araçlık premium garaj sistemlerimiz mevcuttur. Ayrıca projeye özel çoklu çözümler de geliştiriyoruz.',
    q3: 'Her villa için aynı model mi uygulanıyor?',
    a3: 'Hayır. Her proje, villanın mimarisi, ölçüleri ve müşterinin ihtiyaçlarına göre özel olarak tasarlanır; standart bir model kullanılmaz.',
    q4: 'Çoklu villa projelerinde çalışıyor musunuz?',
    a4: 'Evet, çoklu villa projelerinde inşaat firmaları ve proje geliştiricileriyle çalışıyor, proje bazlı özel çözümler sunuyoruz.',
    q5: 'Kış bahçesi de yapılabiliyor mu?',
    a5: 'Evet. Garaj sistemlerine ek olarak kış bahçesi ve garaj + kış bahçesi bütünleşik çözümleri sunuyoruz.',
    q6: 'Fiyat nasıl belirleniyor?',
    a6: 'Fiyatlandırma; ölçüler, araç kapasitesi, mimari detaylar, malzeme tercihleri ve proje kapsamına göre belirlenir.',
    q7: 'Projeyi nasıl gönderebilirim?',
    a7: 'Web sitemizdeki formu doldurabilir, WhatsApp üzerinden (+90 542 799 47 89) ulaşabilir veya Instagram (@villagarage90) üzerinden mesaj gönderebilirsiniz.',
  },
  about: {
    title: 'Hakkımızda',
    text: 'VILLAGARAGE, premium villa garajı ve dış yaşam alanları için mimari çözümler geliştiren bir markadır. Garajı bağımsız bir yapı değil, villanın mimarisinin ayrılmaz bir parçası olarak ele alır; her projede antrasit sistemler, doğal ahşap detaylar ve özel cephe tasarımlarıyla yaşam alanlarına kalıcı değer katar. Villa sahipleri, mimarlar, müteahhitler ve proje geliştiricilerle çalışarak her ihtiyaca özel, mimariyle bütünleşen premium çözümler sunar.',
  },
  final: {
    title: 'Villanızın Mimarisini Garajınızla Tamamlayın.',
    cta1: 'Projeniz İçin Teklif Al',
    cta2: "WhatsApp'tan İletişime Geç",
  },
  roles: {
    member: 'Normal Üye',
    dealer_a: 'A Sınıfı Bayi',
    dealer_b: 'B Sınıfı Bayi',
    dealer_c: 'C Sınıfı Bayi',
    distributor: 'Plasiyer',
    architect: 'Mimar',
    construction: 'İnşaat Firması',
    realtor: 'Emlakçı',
    admin: 'Yönetici',
  },
  catalog: {
    title: 'Garaj Sistemleri',
    all: 'Tümü',
    cat: {
      standard: 'Standart Garajlar',
      custom: 'Özel Tasarım Garajlar',
      luxury: 'Lüks Garajlar',
    },
    tag: {
      new: 'Yeni',
      single: 'Tek Araçlık',
      double: 'Çift Araçlık',
      premium: 'Premium',
      project: 'Projeye Özel',
    },
    capacityLabel: 'Araç Kapasitesi',
    singleCar: '1 Araç',
    doubleCar: '2 Araç',
    multiCar: 'Çoklu Araç',
    quote: 'Teklif Al',
    details: 'Detaylar',
    addToCart: 'Sepete Ekle',
    projectQuote: 'Projeye Özel Teklif Oluştur',
    from: 'Başlangıç',
    priceOnRequest: 'Fiyat için teklif alın',
    empty: 'Bu kategoride henüz ürün bulunmuyor.',
    p1: { desc: 'Tek araç için mimariye özel, kompakt ve şık premium garaj çözümü.' },
    p2: { desc: 'İki araç için geniş, ferah ve villanızla bütünleşen premium garaj.' },
    p3: { desc: 'Villanıza özel tasarlanan, mimariyle bütünleşen tek araçlık özel garaj.' },
    p4: { desc: 'Özel tasarım, çift araçlık mimari garaj çözümü.' },
    p5: { desc: 'En üst segment malzeme ve detaylarla lüks villa garajı.' },
    p6: { desc: 'Çoklu villa projeleri için proje bazlı özel garaj sistemleri.' },
  },
  currency: {
    label: 'Para Birimi',
    planned: 'Yakında',
  },
  auth: {
    title: 'Üye / Bayi Girişi',
    subtitle: 'Rolünüze özel panele ve fiyatlandırmaya erişin.',
    email: 'E-posta',
    password: 'Şifre',
    submit: 'Giriş Yap',
    note: 'Güvenli giriş ve rol bazlı yetkilendirme, backend bağlantısı tamamlandığında aktif olacaktır.',
    comingSoon: 'Giriş altyapısı hazır. Güvenli backend bağlantısı tamamlandığında bu ekran aktif olacaktır.',
    roleInfoTitle: 'Rol Bazlı Erişim',
    roleInfoText: 'Normal üye, A/B/C sınıfı bayiler, plasiyer, mimar, inşaat firması, emlakçı ve yönetici rolleri desteklenir. Her rol yalnızca yetkili olduğu alanları görür; yetkilendirme sunucu tarafında uygulanır.',
    applyCta: 'Bayilik & İş Ortaklığı başvurusu yapın',
    backHome: 'Ana Sayfaya Dön',
  },
  dealer: {
    badge: 'İş Ortaklığı Ağı',
    heroTitle: 'VILLAGARAGE İş Ortaklığı Ağına Katılın',
    heroSubtitle: 'Türkiye ve uluslararası pazarlarda VILLAGARAGE premium garaj sistemlerini müşterilerinizle buluşturun.',
    heroCta: 'Başvuru Yap',
    modelsTitle: 'Üyelik ve Bayilik Modelleri',
    modelsSubtitle: 'Bireysel müşterilerden profesyonel bayilere kadar her seviye için bir yapı.',
    cardCta: 'Detaylı Bilgi & Başvuru',
    models: {
      standard: { name: 'Standart Üyelik', desc: 'Bireysel müşteriler ve normal üyeler için temel üyelik.' },
      a: { name: 'A Sınıfı Bayilik', desc: 'En kapsamlı bayilik modeli. İndirim, kota, teminat ve ödeme avantajları yönetici tarafından belirlenir.' },
      b: { name: 'B Sınıfı Bayilik', desc: 'Orta ölçekli bayiler için dengeli bir iş ortaklığı modeli.' },
      c: { name: 'C Sınıfı Bayilik', desc: 'Yeni başlayan bayiler için giriş seviyesi iş ortaklığı modeli.' },
    },
    proTitle: 'Profesyonel İş Ortaklığı',
    proSubtitle: 'Proje ve müşteri yönlendiren profesyoneller için esnek iş ortaklığı modeli.',
    proSectors: 'Mimarlar • İnşaat Firmaları • Emlakçılar • Plasiyerler',
    partnerCta: 'İş Ortağı Ol',
    partnersTitle: 'İş Ortağı Modelleri',
    partners: {
      distributor: 'Plasiyer',
      architect: 'Mimar',
      construction: 'İnşaat Firması',
      realtor: 'Emlakçı',
      other: 'Diğer İş Ortağı',
    },
    partnersNote: 'Bayi kotası veya teminatı olmadan; her gruba özel indirim, fiyatlandırma avantajı ve yetki seviyesi tanımlanır.',
    termsTitle: 'Sınıfa Özel Koşullar',
    termsText: 'İndirim oranları, satın alma kotaları, teminat miktarları ve ödeme avantajları her bayilik sınıfı için ayrı ayrı belirlenir ve yönetici panelinden yönetilir. Bu değerler şu anda sabit değildir.',
    rolesTitle: 'Rol Yapısı',
    rolesSubtitle: 'Her kullanıcı yalnızca kendi rolüne izin verilen alanları görür; yetkilendirme güvenli backend bağlantısı sonrası sunucu tarafında uygulanır.',
    form: {
      title: 'Başvuru Formu',
      subtitle: 'Aşağıdaki formu doldurun; başvurunuz değerlendirilmek üzere alınacaktır.',
      name: 'Ad Soyad',
      company: 'Firma Adı',
      phone: 'Telefon',
      email: 'E-posta',
      country: 'Ülke',
      city: 'Şehir',
      website: 'Web Sitesi',
      instagram: 'Instagram',
      field: 'Faaliyet Alanı',
      applicationType: 'Başvuru Türü',
      selectPlaceholder: 'Seçiniz',
      howToWork: 'VILLAGARAGE ile nasıl çalışmak istiyorsunuz?',
      messagePh: 'Kısaca anlatın...',
      submit: 'Başvurumu Gönder',
      success: 'Başvurunuz değerlendirilmek üzere alınmıştır.',
      error: 'Bir şeyler ters gitti. Lütfen tekrar deneyin.',
    },
  },
  footer: {
    tagline: 'Premium Garage Systems',
    navTitle: 'Menü',
    contactTitle: 'İletişim',
    instagram: 'Instagram',
    copyright: 'Tüm hakları saklıdır.',
  },
};